import axios from 'axios';

//enter your API key in the string below
const KEY = 'AIzaSyABLZY5JoGdQzgEkhzephJ5eH-QuzK-VpE';

export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3',
    params: {
        part: 'snippet',
        maxResults: 1,
        key: KEY
    }
});